import './logoSidebar.scss'
import templateUrl from './logoSidebar.html'

/**
 * logoSidebar component.
 *
 * Used by the `logoSidebar` view of the {@link tmrDefaultAppState `app` state}.
 *
 * @example
 * <tmr-logo-sidebar></tmr-logo-sidebar>
 *
 * @type {ngComponent}
 */
export const tmrLogoSidebar = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrLogoSidebarController',
  require: {
    app: '^^tmrApp',
  },
}

/**
 * Controller of component {@link tmrLogoSidebar}.
 *
 * @type {ngController}
 */
export class tmrLogoSidebarController {
  static ngType = 'controller'

  onMenuCollapseClick() {
    if (this.app.fixed) this.app.unfixSidebar()
    else this.app.fixSidebar()
  }
}
